// FiltersForm.jsx

import React, { useState } from "react";

const FiltersForm = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedJurisdiction, setSelectedJurisdiction] = useState("");

  const categoriesOptions = [
    "Slotmill",
    "Evoplay",
    "Relax",
    "Silver Bullet",
    "Pragmatic",
     "Booming Games",
     "Iron Dog Studio",
     "Playson",
     "Red Rake",

    // "Jackpot Games", "Live Dealer", "Live Video Slots", "Lottery", "Mini Games", "Other",
    // "Poker", "Roulette", "Scratch Cards", "Sic Bo", "Table Games", "Video Pokers", "Video Slots",
    // "Virtual Sports", "Limitless Blackjack"
  ];

  const jurisdictionsOptions = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MN',
    'MS',
    'MO',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WV',
    'WI',
    'WY',
    // "Alderney", "Argentina", "Argentina Province", "Bahamas", "Belarusian", "Brazil", "Bulgaria",
    // "Chile", "Colombia", "Connecticut", "Croatia", "Curacao", "Denmark", "Estonia", "Georgia",
    // "German", "Greece", "Hungary", "Italy", "Kahnawake", "Latvia", "Lithuania", "Malta",
    // "Michigan", "Netherlands", "New Jersey", "Ontario", "Pennsylvania", "Peru", "Portugal",
    // "Romania", "Schleswig-Holstein", "Spain", "Sweden", "Switzerland", "Ukraine", "United Kingdom", "West Virginia"
  ];

  return (
    <div className="container form_filter">
      <div className="row justify-content-center mt-5 mb-4">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search Vendor"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="col-md-4">
          <select
            className="form-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Category</option>
            {categoriesOptions.map((category, idx) => (
              <option key={idx} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <select
            className="form-select"
            value={selectedJurisdiction}
            onChange={(e) => setSelectedJurisdiction(e.target.value)}
          >
            <option value="">Jurisdiction</option>
            {jurisdictionsOptions.map((jurisdiction, idx) => (
              <option key={idx} value={jurisdiction}>
                {jurisdiction}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FiltersForm;
